
import ForgotForm from "../pages/forgotPassword";
import LoginForm from "../pages/login";
export default [
    {
        path: '/login',
        name: 'login',
        component: LoginForm,
        meta: { jwtRequiresAuth: false, requiresAuth: false },
        beforeEnter: (to, from, next) => {
            let accessToken = localStorage.getItem("accessToken");
            if (accessToken) {
                next('/')
            } else {
                next();
            }
        }

    },
  
    {
        path: '/forgot-me',
        name: 'forgotme',
        props: false,
        component: ForgotForm,
        meta: { requiresAuth: false}
        
    }
]